var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bgfff mt20"},[_c('el-empty',{attrs:{"description":_vm.description}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }